<script>
  import reveal from '../lib/actions/reveal.js';
  import SectionHeader from '../lib/ui/SectionHeader.svelte';
  import GlowCard from '../lib/ui/GlowCard.svelte';
</script>

<section id="roadmap" class="section" aria-label="Building the Agentic Future">
  <div class="container">
    <div use:reveal>
      <SectionHeader title="Building the Agentic Future">
        <span slot="desc">From BSC to Base, the agentic economy rapid scales:</span>
      </SectionHeader>
    </div>

    <div class="grid" style="grid-template-columns: repeat(3, 1fr); gap: 18px; margin-top: 16px;">
      <div use:reveal>
        <GlowCard>
        <div class="eyebrow">Phase 1</div>
        <h3 style="margin: 6px 0 8px;">BNB Chain × Maiga</h3>
        <p style="color: var(--muted);">Lumina begins on the BNB Chain, partnering with Maiga to bring NFAs to life</p>
        </GlowCard>
      </div>

      <div use:reveal={{delay:120}}>
        <GlowCard>
        <div class="eyebrow">Phase 2</div>
        <h3 style="margin: 6px 0 8px;">x402 for NFAs</h3>
        <p style="color: var(--muted);">Introduces x402 to NFAs creating the bridge for autonomous a-commerce</p>
        </GlowCard>
      </div>

      <div use:reveal={{delay:240}}>
        <GlowCard>
        <div class="eyebrow">Phase 3</div>
        <h3 style="margin: 6px 0 8px;">Launch on Base</h3>
        <p style="color: var(--muted);">Launch NFAs on Base driving the mass adoption of aGDP</p>
        </GlowCard>
      </div>
    </div>
    <div use:reveal={{delay:320}} style="margin-top: 16px;">
      <p style="color: var(--muted); font-size: 18px;">Lumina transforms NFTs into NFAs, igniting the dawn of agentic commerce.</p>
    </div>
  </div>
</section>
